
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import DateTimeInputField from "@/app/ui/components/date-time-input/field.vue";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { UpdateClientPeriodRequest } from "@/data/payload/api/ClientManagementApiRequest";
import moment from "moment";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  modelValue = prop<any>({
    required: true,
    type: Object
  });
  rateVersionId = prop<number>({
    default: 0
  });
  startDate = prop<string>({
    required: true,
    type: String
  });
}

@Options({
  emits: ["onClosePopup", "onSuccessEdit"],
  components: {
    DateTimeInputField
  }
})

export default class ModalChangePeriodPrice extends Vue.with(Props) {
  onHidePopup() {
    this.$emit("onClosePopup", false);
    this.endDate = "";
  }

  get startDatePeriod() {
    return new Date(this.startDate)
  }

  get minDate() {
    const startDate = new Date(this.startDate);
    const minDate = new Date(startDate.setDate(startDate.getDate() + 1));
    return minDate;
  }

  endDate = "";

  async onSubmit() {
    MainAppController.showLoading();
    try {
      const payload = new UpdateClientPeriodRequest({
        id: this.rateVersionId,
        endDate: moment(this.endDate).format('YYYY-MM-DDTHH:mm:ssZ')
      })
      await ClientManagementController.updateClientPeriod(payload)
      this.endDate = ""
      this.$emit("onSuccessEdit");
      this.onHidePopup()
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, this.$t("clientManagement.changePeriodModal.changePeriodPriceFailed").toString())
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

}
